import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Center, Loader, Stack, Text } from "@mantine/core";

import { signIn } from "@/auth/provider";
import { t } from "@/i18n";

/**
 * Kicks off the OIDC + PKCE flow. Reads `?next=<path>` from the query
 * string so the user lands back on their original destination after the
 * IAM round-trip. Renders a non-interactive loading state while the
 * redirect builds — the component effectively unmounts when the browser
 * navigates away.
 */
export function LoginPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") ?? "/";

  useEffect(() => {
    void signIn(next);
  }, [next]);

  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Loader />
        <Text c="dimmed">{t("login.redirecting")}</Text>
      </Stack>
    </Center>
  );
}
